import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, map } from 'rxjs';
import { RestfulService } from 'src-ironside/services/restful.service';
import { DynamicDocumentService } from 'src/app/shared/services/dynamic-document.service';
import { ResourceFile } from './resource.repository';

export type News = {
    description?: string;
    createdAt?: number;
    updatedAt?: number;
    id?: string;
    title?: string;
    type?: string;
    photo?: ResourceFile[];
    document?: ResourceFile[];
    imageURL?: string;
};

const DYNAMIC_NEWS = 'dynamic_news';

@Injectable()
export class NewsRepository extends RestfulService {
    constructor(
        public override httpClient: HttpClient,
        public override router: Router,
        private dynamicDocumentService: DynamicDocumentService
    ) {
        super(httpClient, router);
    }

    find(
        page = 1,
        pageSize = 150
    ): Observable<{
        content: News[];
        meta: { totalPages: number; pageSize: number; totalItems: number };
    }> {
        return this.dynamicDocumentService
            .find(
                {
                    collectionName: DYNAMIC_NEWS,
                    filters: [],
                    sorts: {
                        creationDate: 'DESC',
                    },
                    page: page,
                    pageSize: pageSize,
                },
                true
            )
            .pipe(
                map((res) => ({
                    content: res.content.map((news: any) => {
                        return this.convertNews(news);
                    }),
                    meta: {
                        pageSize: res.size,
                        totalPages: res.totalPages,
                        totalItems: res.totalElements,
                    },
                }))
            );
    }

    findById(id: string): Observable<News> {
        return this.doGet(`dynamic-documents/dynamic_news/${id}`).pipe(
            map((res) => this.convertNews(res))
        );
    }

    // ---------------
    convertNews(news: any): News {
        return {
            id: news?.id,
            title: news?.subject,
            description: news?.description,
            type: news?.typeOfNews?.labels,
            document: news?.document?.map((doc: any) => {
                return { id: doc.resourceFileId, name: doc.name, url: doc.url };
            }),
            photo: news?.photo?.map((photo: any) => {
                return { id: photo.resourceFileId, name: photo.name, url: photo.url };
            }),
        };
    }
}
